import axios from '../core/http';

import { APIcaller } from './APIcaller';
import { config } from '../config';

const baseApiUrl = `${config.baseApiUrl}/v1`;

function getStock(storeIds, startDate, endDate) {
  return axios
    .post(
      baseApiUrl + '/stocks/',
      {
        storeIds: storeIds,
        startDate: startDate,
        endDate: endDate,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('loopbackAccessToken'),
        },
      },
    )
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
}

const getStockGraph = (
  storeId,
  entityId,
  date,
  includeRecipeStock = false,
  allowNegativeTheoreticalStock = false,
) => {
  const url = `${baseApiUrl}/stocks/stores/${storeId}/ingredients/${entityId}?date=${date}&includeRecipeStock=${includeRecipeStock}&allowNegativeTheoreticalStock=${allowNegativeTheoreticalStock}`;
  return axios
    .get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

const getPastStocksOfIngredientsByCategories = (
  storeId,
  date,
  categoryIds,
  isStrategic,
  includeRecipeStock = false,
  allowNegativeTheoreticalStock = false,
) =>
  APIcaller.apiPost('/stocks/analytics/past', {
    date,
    storeId,
    categoryIds,
    isStrategic,
    includeRecipeStock,
    allowNegativeTheoreticalStock,
  });

const getPastStocksDates = (storeId, startDate, endDate) =>
  APIcaller.apiPost('/stocks/analytics/past/dates', {
    storeId,
    startDate,
    endDate,
  });

export const stock = {
  getStock,
  getStockGraph,
  getPastStocksOfIngredientsByCategories,
  getPastStocksDates,
};
